import { MarketAppVisibility } from 'domain/entity/market/marketApp';
import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface ReadMarketAppsCriteria {
    visibility: MarketAppVisibility;
}

class ReadMarketAppsCriteriaImpl implements ReadMarketAppsCriteria {
    constructor(readonly visibility: MarketAppVisibility) {}
}

export class ReadMarketAppsCriteriaBuilder {
    private visibility: Option<MarketAppVisibility> = none;

    static create = (): ReadMarketAppsCriteriaBuilder => new ReadMarketAppsCriteriaBuilder();

    withVisibility = (visibility: MarketAppVisibility): ReadMarketAppsCriteriaBuilder => {
        this.visibility = some(visibility);

        return this;
    };

    build = (): ReadMarketAppsCriteria => {
        if (isNone(this.visibility)) {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadMarketAppsCriteriaImpl(this.visibility.value);
    };
}
